import { get } from 'lodash';

import { money } from 'hb-react/shared/apps/Memberships/utils/money';

export const userFieldsConfiguration = (userFieldsConfig) => ({
  getLabel: (label, fallback) => userFieldsConfig?.[label] || I18n.t(fallback),
  getPostalPlaceholder: (addressType) => (field) =>
    get(userFieldsConfig, `postal_${addressType}_${field}_placeholder`),
});

const membershipsTransformer = (memberships) => {
  const paymentOptions = memberships
    .flatMap(({ payment_options: paymentOptions = [] }) =>
      paymentOptions.find(({ selected }) => selected),
    )
    .filter(Boolean);

  if (paymentOptions.length > 0) {
    return paymentOptions.map((option) => ({
      ...option,
      type: 'payment_option',
    }));
  }

  return memberships.map((m) => ({
    ...m,
    type: 'membership',
  }));
};

export const transformFormStateToOrder = ({
  memberships,
  donations = [],
  addons = [],
  billing_address_attributes: billingAddressAttributes = {},
  shipping_address_attributes: shippingAddressAttributes = {},
  ...user
}) => ({
  cart: {
    currency: memberships[0].currency,
    billing_address_attributes: billingAddressAttributes,
    shipping_address_attributes: shippingAddressAttributes,
    cart_items: [
      ...membershipsTransformer(memberships),
      donations
        .filter(({ amount = 0 }) => amount > 0)
        .map((m) => ({
          ...m,
          type: 'donation',
          price: m.amount,
        })),
      addons
        .filter(({ quantity = 0 }) => quantity > 0)
        .map((m) => ({ ...m, type: 'addon' })),
    ]
      .flat()
      .filter(Boolean)
      .map(
        ({
          type,
          id,
          recurring_payment_enabled: recurring = false,
          price,
          quantity = 1,
        }) => ({
          type,
          total_in_cents: money(price).cents * quantity,
          line_itemable_id: id,
          quantity,
          recurring,
        }),
      ),
  },
  user,
});
